/**
 * Global state for channels
 */
export function createState() {
    return {
        byId: {},
    };
}
